export enum ImageSize {
    Small = 'small',
    Large = 'large'
}